import ImageBanner from '../../components/ImageBanner';
import BannerTitle from '../../components/BannerTitle';
import StoreFinder from '../../components/StoreFinder';
import Head from 'next/head';

/**
 * List all locations
 * @return {JSX.Element}
 * @constructor
 */
function LocationsPage() {
  return <div>
    <>
      <Head>
        <title>Shaking Crab | Find Us</title>
      </Head>
      <ImageBanner image={`https://tools.shakingcrab.com/storage/images/c5/1246eb011eba490d78c7be5cc3bcff.jpg`}>
        <BannerTitle title={`Find a Shaking Crab`}/>
      </ImageBanner>
      <StoreFinder/>
    </>
  </div>;
}

export default LocationsPage;
